<template>
<div class="chapter">
<div class="inner_page">
<p class="noindents1"><a id="ch00_fm02_pre01"></a><a id="page_ii"></a><span class="small">ANIMALS, HISTORY, CULTURE</span><br/>Harriet Ritvo, <em>Series Editor</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_pre01.vue?315da82a